import { type FC } from 'react';
import { graphql, useRefetchableFragment } from 'react-relay';
import { usePdpRecentHistoryTracker } from '../../hooks/usePdpRecentHistoryTracker';

// components
import { BrowserHistoryContextProvider } from '../../../global/BrowserHistoryContext/BrowserHistoryContext';
import { PdpRespMarketplaceLayoutPrimaryContextProvider } from './PdpRespMarketplaceLayoutPrimaryContextProvider';
import { PdpRespMarketplaceContainerPrimary } from '../PdpRespMarketplaceContainer/PdpRespMarketplaceContainerPrimary';
import { PdpSharedOriginalLanguageProvider } from '../../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';
import { PdpRespMarketplaceStickyHeaderContextProvider } from '../PdpRespMarketplaceStickyHeader/PdpRespMarketplaceStickyHeaderContext';

// types
import { type PdpRespMarketplaceLayoutPrimary_viewer$key as Viewer } from './__generated__/PdpRespMarketplaceLayoutPrimary_viewer.graphql';

const viewerFragment = graphql`
    fragment PdpRespMarketplaceLayoutPrimary_viewer on Viewer
    @refetchable(queryName: "PdpRespMarketplaceLayoutPrimaryRefetchQuery") {
        ...PdpRespMarketplaceContainerPrimary_viewer
        ...PdpRespMarketplaceLayoutPrimaryContextProvider_viewer
        itemRead(itemIds: $itemIds) {
            ... on Item {
                ...usePdpRecentHistoryTracker_item
                ...PdpSharedOriginalLanguageProvider_item
            }
        }
    }
`;

export const PdpRespMarketplaceLayoutPrimary: FC<{
    viewer: Viewer;
}> = ({ viewer: viewerRef }) => {
    const [viewer, refetch] = useRefetchableFragment(viewerFragment, viewerRef);
    const item = viewer.itemRead?.[0] || null;

    usePdpRecentHistoryTracker({ item });

    if (!item) {
        return null;
    }

    return (
        <BrowserHistoryContextProvider>
            <PdpSharedOriginalLanguageProvider item={item}>
                <PdpRespMarketplaceLayoutPrimaryContextProvider viewer={viewer} refetch={refetch}>
                    <PdpRespMarketplaceStickyHeaderContextProvider>
                        <PdpRespMarketplaceContainerPrimary viewer={viewer} />
                    </PdpRespMarketplaceStickyHeaderContextProvider>
                </PdpRespMarketplaceLayoutPrimaryContextProvider>
            </PdpSharedOriginalLanguageProvider>
        </BrowserHistoryContextProvider>
    );
};
